import { render, staticRenderFns } from "./defaultManagement.vue?vue&type=template&id=6f945f62&"
import script from "./defaultManagement.vue?vue&type=script&lang=js&"
export * from "./defaultManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f945f62')) {
      api.createRecord('6f945f62', component.options)
    } else {
      api.reload('6f945f62', component.options)
    }
    module.hot.accept("./defaultManagement.vue?vue&type=template&id=6f945f62&", function () {
      api.rerender('6f945f62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/defaultManagement.vue"
export default component.exports